export const update = {
  updateSuccessfully: 'Update language successfully!',
}
